import {
  GET_ALL_PARTICIPANTS_PAGINATE_ERROR,
  GET_ALL_PARTICIPANTS_PAGINATE,
  GET_ALL_PARTICIPANTS_PAGINATE_SUCCESS,
  GET_PARTICIPANTS_LIST_PROCESS,
  GET_PARTICIPANTS_LIST_PROCESS_ERROR,
  GET_PARTICIPANTS_LIST_PROCESS_SUCCESS,
  GET_FUNCTION_BY_PROCESS,
  GET_FUNCTION_BY_PROCESS_ERROR,
  GET_FUNCTION_BY_PROCESS_SUCCESS,
  GET_DNI_DATA,
  GET_DNI_DATA_ERROR,
  GET_DNI_DATA_SUCCESS,
  SET_SELECTED_ITEM_SUCCESS,
  SET_RESET_FORM_SUCCESS,
  SET_NEW_PERSON_SUCCESS,
  SET_RESET_ITEM_SELECTED_SUCCESS,
  SET_PROCESS_ID_SUCCESS,
  SET_FUNCTION_ID_SUCCESS,
  SET_RESET_PART_FORM_SUCCESS,
  SET_RESET_DNI_ERROR_API_SUCCESS,
  SET_RESET_SELECTS,
  SET_RESET_SELECTED_PERSON,
  SET_VOID_PARTICIPANT_PAGINATE_LIST,
  SET_ADD_START_DATE_SUCCESS,
  SET_ADD_END_DATE_SUCCESS,
  GET_PURCHASING_MECHANISM_ACRONYMUS_DICTIONARY
} from './ManageParticipants.actions'
import { PURCHASING_MECHANISM_ACRONYMUS_DICTIONARY } from '../../config/settings/constants'

const initialState = {
  error: false,
  errorProcess: false,
  errorFunctionByProcess: false,
  loading: true,
  loadingProcess: true,
  loadingFunctionByProcess: false,
  loadingDni: false,
  allParticipants: [],
  selectedList: [],
  process: [],
  processMechanismDic: PURCHASING_MECHANISM_ACRONYMUS_DICTIONARY,
  functions: [],
  processOptionSelect: [],
  page: 0,
  total: 0,
  totalPage: 0,
  size: 0,
  dniServiceError: false,
  dniData: {},
  dniErrors: [],
  dniName: '',
  dniLastName: '',
  dniFullName: '',
  dniRole: '',
  dni: '',
  email: '',
  isForeignPerson: 0,
  isOfficialOfInstitution: 0,
  filterUsed: false,
  itemSelected: false,
  functionIdSelected: '',
  processIdSelected: '',
  selectedFullName: '',
  selectedRole: '',
  selectedDni: '',
  selectedEmail: '',
  startDate: '',
  endDate: ''
}

/**
 * The reducer for the Participants List
 */
const manageParticipantsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_VOID_PARTICIPANT_PAGINATE_LIST: {
      return {
        ...state,
        loading: false
      }
    }
    case SET_RESET_SELECTED_PERSON: {
      return {
        ...state,
        functions: [],
        functionIdSelected: '',
        processIdSelected: '',
        itemSelected: false,
        isForeignPerson: 0,
        selectedFullName: '',
        selectedRole: '',
        selectedDni: '',
        selectedEmail: '',
        isOfficialOfInstitution: 0,
        startDate: '',
        endDate: ''
      }
    }
    case SET_ADD_START_DATE_SUCCESS: {
      return { ...state, startDate: payload.startDate }
    }
    case SET_ADD_END_DATE_SUCCESS: {
      return { ...state, endDate: payload.endDate }
    }
    case SET_FUNCTION_ID_SUCCESS: {
      return {
        ...state,
        functionIdSelected: payload.functionIdSelected,
        loading: false,
        error: false
      }
    }
    case SET_PROCESS_ID_SUCCESS: {
      return {
        ...state,
        processIdSelected: payload.processIdSelected,
        functionIdSelected: '',
        loading: false,
        error: false
      }
    }
    case SET_NEW_PERSON_SUCCESS: {
      return {
        ...state,
        selectedList: payload.selectedList,
        allParticipants: payload.allParticipants,
        itemSelected: payload.itemSelected,
        page: payload.page,
        selectedDni: payload.selectedDni,
        selectedEmail: payload.selectedEmail,
        selectedFullName: payload.selectedFullName,
        selectedRole: payload.selectedRole,
        isForeignPerson: payload.isForeignPerson,
        isOfficialOfInstitution: payload.isOfficialOfInstitution,
        loading: false,
        error: false
      }
    }
    case SET_RESET_FORM_SUCCESS: {
      return {
        ...state,
        dniData: {},
        dniErrors: [],
        dniName: '',
        dniLastName: '',
        dniFullName: '',
        dniRole: '',
        email: '',
        dni: '',
        dniServiceError: false,
        loading: false
      }
    }
    case SET_RESET_PART_FORM_SUCCESS: {
      return {
        ...state,
        dniData: {},
        dniErrors: [],
        dniName: '',
        dniLastName: '',
        dniFullName: '',
        dniRole: '',
        email: '',
        dniServiceError: false
      }
    }
    case SET_RESET_ITEM_SELECTED_SUCCESS: {
      return {
        ...state,
        dniData: {},
        dniErrors: [],
        dniName: '',
        dniLastName: '',
        dniFullName: '',
        dniRole: '',
        email: '',
        dni: '',
        dniServiceError: false,
        isForeignPerson: 0,
        isOfficialOfInstitution: 0,
        loading: false
      }
    }
    case SET_SELECTED_ITEM_SUCCESS: {
      return {
        ...state,
        selectedList: payload.selectedList,
        itemSelected: payload.itemSelected,
        dniFullName: payload.dniFullName,
        dniRole: payload.dniRole,
        isForeignPerson: payload.isForeignPerson,
        email: payload.email,
        dni: payload.dni,
        selectedFullName: payload.selectedFullName,
        selectedRole: payload.selectedRole,
        selectedDni: payload.selectedDni,
        selectedEmail: payload.selectedEmail,
        isOfficialOfInstitution: payload.isOfficialOfInstitution,
        loading: false,
        error: false
      }
    }
    case SET_RESET_SELECTS: {
      return {
        ...state,
        functionIdSelected: '',
        startDate: '',
        endDate: ''
      }
    }
    case GET_ALL_PARTICIPANTS_PAGINATE: {
      return { ...state, loading: payload.loading ?? true, error: false }
    }
    case GET_ALL_PARTICIPANTS_PAGINATE_ERROR: {
      return { ...state, loading: false, error: true }
    }
    case GET_ALL_PARTICIPANTS_PAGINATE_SUCCESS: {
      return {
        ...state,
        selectedList: payload.selectedList,
        allParticipants: payload.allParticipants,
        page: payload.page,
        total: payload.total,
        totalPage: payload.totalPage,
        size: payload.size,
        filterUsed: payload.filterUsed,
        loading: false,
        error: false
      }
    }
    case GET_PARTICIPANTS_LIST_PROCESS: {
      return { ...state, loadingProcess: true, errorProcess: false }
    }
    case GET_PARTICIPANTS_LIST_PROCESS_ERROR: {
      return { ...state, loadingProcess: false, errorProcess: true }
    }
    case GET_PARTICIPANTS_LIST_PROCESS_SUCCESS: {
      return {
        ...state,
        process: payload.process,
        loadingProcess: false,
        errorProcess: false
      }
    }
    case GET_FUNCTION_BY_PROCESS: {
      return { ...state, loadingFunctionByProcess: true, errorFunctionByProcess: false }
    }
    case GET_FUNCTION_BY_PROCESS_ERROR: {
      return { ...state, loadingFunctionByProcess: false, errorFunctionByProcess: true }
    }
    case GET_FUNCTION_BY_PROCESS_SUCCESS: {
      return {
        ...state,
        functions: payload.functions,
        loadingFunctionByProcess: false,
        errorFunctionByProcess: false
      }
    }
    case GET_DNI_DATA: {
      return { ...state, loadingDni: true, dniServiceError: false }
    }
    case GET_DNI_DATA_ERROR: {
      return {
        ...state,
        loadingDni: false,
        dniServiceError: true,
        dniErrors: payload.dniErrors
      }
    }
    case SET_RESET_DNI_ERROR_API_SUCCESS: {
      return {
        ...state,
        loadingDni: false,
        dniServiceError: false,
        dniErrors: []
      }
    }
    case GET_DNI_DATA_SUCCESS: {
      return {
        ...state,
        dniData: payload.dniData,
        dniErrors: payload.dniErrors,
        dniName: payload.dniName,
        dniLastName: payload.dniLastName,
        dniFullName: payload.dniFullName,
        dniRole: payload.dniRole,
        loadingDni: false,
        dniServiceError: payload.dniServiceError
      }
    }
    case GET_PURCHASING_MECHANISM_ACRONYMUS_DICTIONARY: {
      const { processMechanismDic = PURCHASING_MECHANISM_ACRONYMUS_DICTIONARY } = payload
      return {
        ...state,
        processMechanismDic
      }
    }
    default: {
      return state
    }
  }
}

export default manageParticipantsReducer
